import Vue from "vue";
import debounce from "./src/debounce";
import positiveInteger from "./src/positiveInteger";
import positivePoint from "./src/positivePoint";
import minusPoint2 from "./src/minusPoint2";
import regexFilter from "./src/regexFilter";

// 防重复点击
Vue.directive("debounce", debounce);
// 只能输入正整数(包括0)
Vue.directive("positiveInteger", positiveInteger);
// 只能输入正整数(包括0)或小数，小数只保留指定位数
Vue.directive("positivePoint", positivePoint);
// 只能输入正负数字(包括0)或正负小数，小数只保留2位
Vue.directive("minusPoint2", minusPoint2);
// 只能输入通过正则条件的字符
Vue.directive("regexFilter", regexFilter);
